<template>
  <div
      class="promo__content"
      v-for="(item, index) in promocodes"
      :key="`promocode_${index}`"
  >
    <v-row
        no-gutters
        class="promo__block"
    >
      <v-col class="promo__block_logo">
        <v-img
            alt="placeholder_partner"
            :max-width="$vuetify.display.width >= 1280 ? 170 : 250"
            width="100%"
            :max-height="$vuetify.display.width >= 1280 ? 150 : 100"
            :src="getFileLink(item.logo.link)"
        />
      </v-col>
      <v-col class="promo__block_text">
        {{ item.description }}
      </v-col>
      <v-col class="promo__block_code">
        <div>
          <div class="promo__block_code--usage">
            <span v-if="item.uses_count !== undefined">
              <span v-if="item.uses_count === 0">Применен: нет лимита</span>
              <span v-else>Применен: {{ item.uses }} из {{ item.uses_count }}</span>
            </span>
            <span
                v-else-if="item.is_annul"
            >
              Не действует
            </span>
            <span v-else>
              <span v-if="item.expire && !item.is_expire">Действует до {{ displayDate(item.expire) }}</span>
              <span v-else-if="item.is_expire">Действовал до {{ displayDate(item.expire) }}</span>
              <span v-else>Доступен к применению</span>
            </span>
          </div>
          <div
              class="promo__block_code--number"
              @click="!loading ? userTakePromocode(item) : ''"
          >
            <div
                class="promo__block_code--cover"
                v-if="item.cover"
            >
              <v-img
                  alt="promocode_cover"
                  height="40"
                  :src="promocode_cover"
              />
            </div>
            <p v-else>{{ item.value }}</p>
          </div>
          <div>
            <v-btn
                v-if="!item.cover && !item.is_annul && !item.is_expire"
                @click="copyInClipboard(item)"
                :color="item.copy ? '#ffffff' : '#376FFE'"
                width="110"
                height="25"
                elevation="0"
                :class="item.copy ? 'promo__block_btn copy' : 'promo__block_btn'"
            >
              <span v-if="item.copy">Скопировано</span>
              <span v-else>Скопировать</span>
            </v-btn>
            <div
                v-else-if="item.is_annul"
                class="promo__block_btn copy annul"
            >
              Аннулирован
            </div>
            <div
                v-else-if="item.is_expire"
                class="promo__block_btn copy annul"
            >
              Просрочен
            </div>
            <div v-else class="promo__block_code--date">
              <span v-if="item.expire && !item.is_expire">Действует до {{ displayDate(item.expire) }}</span>
              <span v-else-if="item.is_expire">Действовал до {{ displayDate(item.expire) }}</span>
              <span v-else>Действует бессрочно</span>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import promocode_cover from "@/assets/img/promocode_cover.svg"
import { displayDate } from "@/helper"
import helper from "@/urls/helper"
import { mapActions } from "vuex"

export default defineComponent({
  name: "PromocodeBlock",
  props: {
    promocodes: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      promocode_cover: promocode_cover,
      error: null,
      loading: false,
    }
  },
  methods: {
    ...mapActions({
      takePromocode: 'personal_account/promocodes/takePromocode'
    }),
    displayDate: displayDate,
    userTakePromocode (item) {
      if (item.cover) {
        this.loading = true
        this.takePromocode(
          {
            id: item.id,
            finalizer: (data) => {
              item.cover = false
              item.value = data.value
              this.loading = false
            },
            catcher: (error) => {
              item.cover = false
              item.value = 'ОШИБКА'
              this.error = error
              this.loading = false
            }
          }
        )
      } else {
        this.copyInClipboard(item)
      }
    },
    getFileLink (url) {
      return helper.getMendeleevUrlWithParameters(url.basename, url.action, url.params, null)
    },
    copyInClipboard (item) {
      try {
        navigator.clipboard.writeText(item.value)
        item.copy = true
        setTimeout(() => {
          item.copy = false
        }, "2000")
      } catch (e) {
        console.log(e)
      }
    },
  }
})
</script>

<style scoped lang="scss">
.promo__content {
  padding: 50px 50px 0;

  &:last-child {
    padding-bottom: 50px;
  }
}

.promo__block {
  height: 176px;
  box-sizing: border-box;
  border: 1px dashed rgba(49, 55, 67, 1);
  filter: drop-shadow(1px 1px 10px rgba(52, 52, 124, 0.1));
  border-radius: 5px;
}

.promo__block_logo {
  max-width: 21.6%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.promo__block_text {
  max-width: 48.5%;
  padding-inline: 30px 30px !important;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #313743;
}

.promo__block_code {
  max-width: 29.9%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-left: 1px dashed rgba(49, 55, 67, 1);

  &--usage {
    height: 20px;
    margin-bottom: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    color: #3254B9;
  }

  &--number {
    margin: 20px 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 212px;
    height: 40px;
    background-color: #ECEFFB;
    border-radius: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #313743;
  }

  &--cover {
    position: absolute;
    left: 0;
    bottom: 0;
    cursor: pointer;
  }

  &--date {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    height: 20px;
    text-align: center;
    color: #959595;
  }
}

.promo__block_btn {
  border-radius: 25px;
  color: white;
  font-style: normal;
  font-weight: 600;
  text-transform: capitalize;
  font-size: 11px;
  line-height: 15px;

  &.copy {
    color: #376FFE;
    border: 1px solid #376FFE;
  }

  &.annul {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 110px;
    height: 25px;
  }
}

@media screen and (min-width: 961px) and (max-width: 1280px) {
  .promo__block_logo {
    padding-left: 20px !important;
  }
}

@media screen and (max-width: 960px) {
  .promo__content {
    padding: 0 0 50px;

    &:last-child {
      padding-bottom: 0;
    }
  }

  .promo__block {
    height: 371px;
  }

  .promo__block_logo {
    margin-top: 10px;
    margin-bottom: 10px;
    height: 100px;
    width: 100%;
    max-width: 100%;
    min-width: 560px;
  }

  .promo__block_text {
    margin-bottom: 10px;
    width: 100%;
    height: 79px;
    max-width: 100%;
    min-width: 560px;
    padding-inline: 20px 20px !important;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }

  .promo__block_code {
    width: 100%;
    height: 162px;
    max-width: 100%;
    min-width: 560px;
    border-left: none;
    border-top: 1px dashed rgba(49, 55, 67, 1);
  }
}

@media screen and (max-width: 768px) {
  .promo__content {
    padding: 0 0 20px;

    &:last-child {
      padding-bottom: 0;
    }
  }

  .promo__block_logo {
    min-width: 420px;
  }

  .promo__block_text {
    min-width: 420px;
  }

  .promo__block_code {
    min-width: 420px;
  }
}

@media screen and (max-width: 600px) {
  .promo__block_logo {
    min-width: 330px;
  }

  .promo__block_text {
    min-width: 330px;
  }

  .promo__block_code {
    min-width: 330px;
  }
}

@media screen and (max-width: 428px) {
  .promo__block_logo {
    min-width: 290px;
  }

  .promo__block_text {
    min-width: 290px;
  }

  .promo__block_code {
    min-width: 290px;
  }
}

@media screen and (max-width: 369px) {
  .promo__block_logo {
    min-width: 220px;
    padding: 0 10px !important;
  }

  .promo__block_text {
    min-width: 220px;
  }

  .promo__block_code {
    min-width: 220px;
  }
}
</style>
